import { create } from "zustand"

export type DrawerContext = "updates" | "notifications" | "notes" | "word-diary-comment"

interface useDrawerStore {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
  context: DrawerContext | undefined
  taskId?: number
  fromUpdates?: boolean
  setContext: (context: DrawerContext | undefined) => void
  setTaskId: (taskId: number) => void
  updateRecord?: boolean
  [key: string]: any
}

export const useDrawer = create<useDrawerStore>((set) => ({
  isOpen: false,
  context: undefined,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
  fromUpdates: false,
  updateRecord: false,
  setContext: (context: DrawerContext | undefined) => {
    set({ context })
  },
  setFromUpdates: (fromUpdates: boolean) => {
    set({ fromUpdates })
  },
  setTaskId: (taskId: number) => {
    set({ taskId })
  },
  setUpdateRecord: (updateRecord: boolean) => {
    set({ updateRecord })
  },
  setWorkDiaryId: (workDiaryId: number) => {
    set({ workDiaryId })
  },
  workDiaryApprovals: { contractorApproval: false, supervisorApproval: false },
  setWorkDiaryApprovals: (approvals: { contractorApproval: boolean; supervisorApproval: boolean }) => {
    set({ workDiaryApprovals: approvals })
  }
}))
